import { render, staticRenderFns } from "./PaymentReject.vue?vue&type=template&id=be32adb8&"
import script from "./PaymentReject.vue?vue&type=script&lang=js&"
export * from "./PaymentReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports